import { Data } from './data';

export class Compte extends Data {

    designation: string;
    numCompte: number;
    parent: Compte;
    children: Compte[];
    text: string;
    value: number;
    // type_compte: string;


    constructor() {

        super();
        // this.montant = 0;
    }

    /* get text(): string{

        return this.designation;
    }

    get value(): number{

        return this.id;
    } */



}
